import Vue from "vue"

export default {
  getUsers(organisationId) {
    return Vue.axios
      .get(`/organisations/${organisationId}/users/`)
      .then((response) => response)
      .catch((error) => error.response)
  },

  getAvailableMaps(organisationId) {
    return Vue.axios
      .get(`/organisations/${organisationId}/available_maps/`)
      .then((response) => response)
      .catch((error) => error.response)
  },

  editUser(user) {
    return Vue.axios
      .patch(`/users/${user.id}/`, user)
      .then((response) => response)
      .catch((error) => error.response)
  },

  deleteUser(user) {
    return Vue.axios
      .delete(`/users/${user.id}/`, user)
      .then((response) => response)
      .catch((error) => error.response)
  },

  createUser(user) {
    return Vue.axios
      .post("/users/", user)
      .then((response) => response)
      .catch((error) => error.response)
  },
}
